export * from './lib/shared';

// Export interfaces
export * from './lib/interfaces/game.interface';
export * from './lib/interfaces/socket.interface';
export * from './lib/interfaces/room.interface';

// Export DTOs
export * from './lib/dto/game.dto';
export * from './lib/dto/room.dto';

// Export events
export * from './lib/events/game.events';

export * from './lib/constants/board.config';
export * from './lib/constants/color-palette';
export * from './lib/constants/input.config';
export * from './lib/constants/game.config';
export * from './lib/services/color-tokens.initializer';

// Export Socket.io service
export * from './lib/services/socket.service';
